jQuery(function ($) {
    (function ($) {
    // Configurable Mapbox GL version (change if needed)
    var MAPBOX_VERSION = 'v3.3.0';
    var MAPBOX_CSS = 'https://api.mapbox.com/mapbox-gl-js/' + MAPBOX_VERSION + '/mapbox-gl.css';
    var MAPBOX_JS  = 'https://api.mapbox.com/mapbox-gl-js/' + MAPBOX_VERSION + '/mapbox-gl.js';

    // One-time loader promise shared across instances
    var mapboxLoaderPromise = null;

    function loadMapboxOnce() {
        if (window.mapboxgl && window.mapboxgl.Map) return Promise.resolve(window.mapboxgl);
        if (mapboxLoaderPromise) return mapboxLoaderPromise;

        mapboxLoaderPromise = new Promise(function (resolve, reject) {
        // Inject CSS once
        if (!document.querySelector('link[data-mapbox-gl]')) {
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = MAPBOX_CSS;
            link.setAttribute('data-mapbox-gl', '1');
            document.head.appendChild(link);
        }

        // Inject JS once
        if (window.mapboxgl && window.mapboxgl.Map) {
            resolve(window.mapboxgl);
            return;
        }
        var script = document.createElement('script');
        script.src = MAPBOX_JS;
        script.async = true;
        script.defer = true;
        script.onload = function () {
            if (window.mapboxgl && window.mapboxgl.Map) {
            resolve(window.mapboxgl);
            } else {
            reject(new Error('Mapbox GL loaded but mapboxgl.Map not found.'));
            }
        };
        script.onerror = function () {
            reject(new Error('Failed to load Mapbox GL JS.'));
        };
        document.head.appendChild(script);
        });

        return mapboxLoaderPromise;
    }

    // Initialise a single map element
    function initMap($el, options) {
        var lat   = parseFloat($el.data('lat'));
        var lng   = parseFloat($el.data('lng'));
        var zoom  = parseFloat($el.data('zoom')) || options.zoom || 12;
        var style = $el.data('style') || options.style || 'mapbox://styles/mapbox/streets-v12';
        var marker= String($el.data('marker')).toLowerCase() !== 'false' && (options.marker !== false);

        // If options explicitly provide centre, override data-*
        if (Array.isArray(options.center) && options.center.length === 2) {
        lng = parseFloat(options.center[0]);
        lat = parseFloat(options.center[1]);
        }

        if (isNaN(lat) || isNaN(lng)) {
        console.warn('lazyMapbox: invalid lat/lng on element', $el[0]);
        return;
        }

        loadMapboxOnce().then(function (mapboxgl) {
        var token = options.accessToken || window.MAPBOX_ACCESS_TOKEN;
        if (!token) {
            console.error('lazyMapbox: Mapbox access token is required.');
            return;
        }
        mapboxgl.accessToken = token;

        var map = new mapboxgl.Map({
            container: $el[0],
            style: style,
            center: [lng, lat],
            zoom: zoom
        });

        // Optional marker
        if (marker) {
            // Defer until style is ready to ensure correct sprite loads
            map.on('load', function () {
            new mapboxgl.Marker().setLngLat([lng, lat]).addTo(map);
            });
        }

        // Store instance if needed later
        $el.data('mapbox-instance', map);
        }).catch(function (err) {
        console.error(err);
        });
    }

    // IntersectionObserver helper
    function observeOnce(el, onEnter) {
        if (!('IntersectionObserver' in window)) {
        // Fallback: just run immediately
        onEnter();
        return;
        }
        var seen = false;
        var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (!seen && entry.isIntersecting) {
            seen = true;
            io.unobserve(el);
            onEnter();
            }
        });
        }, { root: null, rootMargin: '200px 0px', threshold: 0.01 });
        io.observe(el);
    }

    // jQuery plugin
    $.fn.lazyMapbox = function (opts) {
        var defaults = {
        accessToken: null,             // or use window.MAPBOX_ACCESS_TOKEN
        center: null,                  // [lng, lat] to override data-*
        zoom: 12,
        style: 'mapbox://styles/mapbox/streets-v12',
        marker: true
        };
        var options = $.extend({}, defaults, opts || {});

        return this.each(function () {
        var $el = $(this);
        // Avoid double-init
        if ($el.data('lazy-mapbox-initialised')) return;
        $el.data('lazy-mapbox-initialised', true);

        observeOnce(this, function () {
            initMap($el, options);
        });
        });
    };

    })(jQuery);

    $('.js-mapbox').lazyMapbox({
    accessToken: 'pk.eyJ1IjoidG9tZmJ1eHRvbiIsImEiOiJjbWU1ZHM0YmMwdnUxMmlzY201bG5mdGJwIn0.fU32FI-nVqEUQPHh_r9Uig',
    center: [-1.4635226, 52.9227401], 
    zoom: 16,
    style: 'mapbox://styles/mapbox/standard',
    marker: true
  });
});
